import styled from "styled-components";

export const Homee = styled.section `
    * {
    font-family: Arial, Helvetica, sans-serif;
}
`